<template>
  <div v-if="block?.data.device" class="text-center">

    <button
      @click="sendCommand"
      :disabled="isDisabled"
      :style="{
        backgroundColor: tourSettings.page_action_color,
        color: tourSettings.page_action_text_color
      }"
      :class="[
        'flex mx-auto my-5 py-2 px-6 rounded-full ',
        isDisabled ? 'opacity-40' : 'opacity-100'
      ]"
    >
      {{ $t('button.turn_on') }}
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '../services/api'

export default {
  name: 'ConnectboxBlock',
  props: {
    block: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isDisabled: false
    }
  },
  computed: {
    ...mapGetters('settings', ['tourSettings'])
  },
 
  methods: {
    async sendCommand(e) {
      e.preventDefault()
      console.log("send device command", this.block.data['command']);

      this.isDisabled = true

      if (!this.block.data['command']?.id) {
        console.log("Command ID not found");
        return
      }

      const delay = this.block.data['command']?.auto_off_delay || 0

      try {
        // Send the connectbox message using the API service
        const response = await api.sendConnectboxCommand(
          this.block.data['command']?.id
        )

        if (delay > 0) {
          setTimeout(() => {
            this.isDisabled = false
          }, delay * 1000)
        } else {
          this.isDisabled = false
        }
      } catch (error) {
        console.error('Error sending connectbox message:', error)
        // Re-enable button on error
        this.isDisabled = false
      }

    }
  }
}
</script>